import React from 'react'
import loadable from '@loadable/component'
// Components
import { Skeleton } from '@salesforce/retail-react-app/app/components/shared/ui'
import { routes as _routes } from '@salesforce/retail-react-app/app/routes'
const fallback = <Skeleton height="75vh" width="100%" />
const LeftNavLayout = loadable(() => import('./components/left-nav-layout'), { fallback })
const LeftNav = loadable(() => import('./components/left-nav'), { fallback })

// Support Content pages
const SizingGuide = loadable(() => import('./pages/content/support/sizing-guide/index'), { fallback })
const Shipping = loadable(() => import('./pages/content/support/shipping/index'), { fallback })
const ReturnsExchanges = loadable(() => import('./pages/content/support/returns-exchanges/index'), { fallback })
const CandidatePrivacyNotice = loadable(() => import('./pages/content/support/candidate-privacy-notice/index'), { fallback })
const AccessibilityPolicy = loadable(() => import('./pages/content/support/accessibility-policy/index'), { fallback })
const Promotions = loadable(() => import('./pages/content/promotions'), { fallback });
const SiteMap = loadable(() => import('./pages/content/sitemap'), { fallback });
const Terms = loadable(() => import('./pages/content/support/terms'), { fallback });
const PrivacyPolicy = loadable(() => import('./pages/content/support/privacy-policy'), { fallback });


const SizeGuide = () => (
    <LeftNavLayout sidebar={<LeftNav />}>
        <SizingGuide />
    </LeftNavLayout>
)

const ShippingInformation = () => (
    <LeftNavLayout sidebar={<LeftNav />}>
        <Shipping />
    </LeftNavLayout>
)

const Returns = () => (
    <LeftNavLayout sidebar={<LeftNav />}>
        <ReturnsExchanges />
    </LeftNavLayout>
)

const PrivacyNotice = () => (
    <LeftNavLayout sidebar={<LeftNav />}>
        <CandidatePrivacyNotice />
    </LeftNavLayout>
)

const Accessibility = () => (
    <LeftNavLayout sidebar={<LeftNav />}>
        <AccessibilityPolicy />
    </LeftNavLayout>
)

const SiteMapPage = () => (
    <LeftNavLayout sidebar={<LeftNav />}>
        <SiteMap />
    </LeftNavLayout>
)

const TermsPage = () => (
    <LeftNavLayout sidebar={<LeftNav />}>
        <Terms />
    </LeftNavLayout>
)

const PrivacyPolicyPage = () => (
    <LeftNavLayout sidebar={<LeftNav />}>
        <PrivacyPolicy />
    </LeftNavLayout>
)

const SupportRoutes = [
    {
        path: '/content/size-guide.html',
        component: SizeGuide,
        exact: true
    },
    {
        path: '/content/ordering-information.html',
        component: ShippingInformation,
        exact: true
    },
    {
        path: '/content/returns-exchanges.html',
        component: Returns,
        exact: true
    },
    {
        path: '/content/Candidate-Privacy-Notice.html',
        component: PrivacyNotice,
        exact: true
    },
    {
        path: '/content/footer-ada-policy.html',
        component: Accessibility,
        exact: true
    },
    {
        path: '/sitemap',
        component: SiteMapPage,
        exact: true
    },
    {
        path: '/promotions',
        component: Promotions,
        exact: true
    },
    {
        path: '/content/terms.html',
        component: TermsPage,
        exact: true
    },
    {
        path: '/content/privacy-policy.html',
        component: PrivacyPolicyPage,
        exact: true
    }
]

export default SupportRoutes